import { faChevronLeft, faChevronRight, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Slider, { CustomArrowProps } from 'react-slick';
import { createDisplayLink } from '../../services/helper';
import { VyImage } from '../common/VyImage';

// https://github.com/akiran/react-slick/issues/623#issuecomment-629764816
const shadow: any = {
  WebkitFilter: 'drop-shadow( 1px 1px 1px rgba(0, 0, 0, .8))',
  filter: 'drop-shadow( 1px 1px 1px rgba(0, 0, 0, .8))',
};
const PrevArrow = ({ currentSlide, slideCount, ...props }: CustomArrowProps) => (
  <FontAwesomeIcon {...props} style={{ fill: 'white', ...shadow }} icon={faChevronLeft} />
);
const NextArrow = ({ currentSlide, slideCount, ...props }: CustomArrowProps) => (
  <FontAwesomeIcon {...props} style={{ fill: 'white', ...shadow }} icon={faChevronRight} />
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  autoplaySpeed: 5000,
};

interface SimpleSliderProps {
  slides: string[];
  autoplay?: boolean;
  removeImage?: (id: string) => void;
}

const SimpleSlider = ({ slides, removeImage, autoplay = false }: SimpleSliderProps) => {
  const [activeSlide, setActiveSlide] = useState(0);

  function changedSlide(_: number, newIndex: number) {
    setActiveSlide(newIndex);
  }

  return (
    <div className="relative h-full max-w-full">
      <Slider autoplay={autoplay} beforeChange={changedSlide} {...settings}>
        {slides.length > 0 ? (
          slides.map((slide) => (
            <div key={slide} id={`slide-${slide}`} className="h-0 w-full pb-[25%] relative">
              <VyImage
                id={slide}
                className="w-full bg-center bg-no-repeat bg-contain"
                style={{
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  position: 'absolute',
                }}
              />
              {removeImage && (
                <div
                  onClick={() => removeImage(slide)}
                  className="absolute flex items-center justify-center w-10 h-10 text-white transition-opacity bg-gray-600 rounded-full opacity-75 cursor-pointer bottom-2 hover:opacity-100 left-8 sm:right-8 sm:left-auto">
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              )}
            </div>
          ))
        ) : (
          <div key="default-slide-booth h-full">
            <div
              className="w-full bg-center bg-no-repeat bg-contain"
              style={{
                backgroundImage: `url(${createDisplayLink(undefined)})`,
              }}
            />
          </div>
        )}
      </Slider>
      {/* hide bottom bars if there is one slide */}
      {slides.length > 1 && (
        <ul className="absolute bottom-0 flex w-full mb-3">
          {slides.map((slide, index) => (
            <li className={`w-full rounded-md bg-white mx-1 h-1 ${index === activeSlide ? 'opacity-100' : 'opacity-50'}`} key={slide} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default SimpleSlider;
